import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);


function isTouchDevice() {
	return window.matchMedia("(pointer: coarse)").matches
}

function customCursor(){
	const customCursor = document.querySelectorAll('.custom-cursor-follow')

	if ( isTouchDevice() ) {
		gsap.to( customCursor, { opacity: 0 } )

		return
	}

	if ( customCursor.length > 0 && ! isTouchDevice() ) {
		customCursor.forEach(cursor => {
			/* let diffX = 80
			let diffY = 290
			if ( cursor.parentNode.classList.contains( 'js-banner-video-gallery-slider' ) ) {
				diffX = 75
				diffY = 370
			} */

			gsap.set( cursor, { opacity: 0 } );
			gsap.set( cursor, { xPercent: -50, yPercent: -50 } );

			const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
			const mouse = { x: pos.x, y: pos.y };
			const speed = 0.2;
		
			const xSet = gsap.quickSetter(cursor, "x", "px");
			const ySet = gsap.quickSetter(cursor, "y", "px");
		
			window.addEventListener("mousemove", e => {    
				//mouse.x = e.x - diffX;
				//mouse.y = e.y - diffY;
				mouse.x = e.x;
				mouse.y = e.y;

				if ( cursor.parentNode.contains( e.target ) && ! ( e.target instanceof HTMLAnchorElement && e.target.parentNode.parentNode.classList.contains('slide__content') ) ) {
					gsap.to( cursor, { opacity: 1 } )
				} else {
					gsap.to( cursor, { opacity: 0 } )
				}
			});

			gsap.ticker.add(() => {
				// adjust speed for higher refresh monitors
				const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio()); 
				
				pos.x += (mouse.x - pos.x) * dt;
				pos.y += (mouse.y - pos.y) * dt;
				xSet(pos.x);
				ySet(pos.y);
			});
		});
	}
}

export default customCursor;